import classnames from 'classnames'
import * as React from 'react'
import { connect } from 'react-redux'
import { Col, Collapse, Container, Row } from 'reactstrap'
import * as App from '../../../app'
import * as CommunityConfig from '../../../pages/community-config'
import * as Router from '../../../router'
import * as Link from '../../link'
import * as User from '../../user'
import * as UserMenu from '../user-menu'
import * as Actions from './actions'
import * as Constants from './constants'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

type StateProps = CommunityConfig.WrappedState & Types.WrappedNavState & Router.WrappedState & UserMenu.WrappedState
type Props = StateProps
export const buildNav:
  (links: Types.NavItem[], currentPath: Types.Path, user: User.User, parentHref?: Types.Href) => JSX.Element =
  (links, currentPath, user, parentHref = '') =>
  <ul>
    { links.filter((link) => Utils.userCanSeeMenu(link, user)).map((link, i: number) =>
      <li className={classnames({ active: currentPath === link.href})}
          key={i + link.href + 'nav-link'}>
        {link.isNoLink
        ?
        <span className="link">{link.label}</span>
        :
        <Link.AnchorLink href={link.href}>{link.label}</Link.AnchorLink>
        }
        {link.children ? buildNav(link.children, currentPath, user, link.href) : null}
      </li>)}
  </ul>

export const LeftNavComponent: ({communityConfig, navState, router, userMenu}: Props) => JSX.Element =
({communityConfig, navState, router, userMenu}) => <div className="left-nav">
  <Container>
    {communityConfig.logo && <div className="community-logo">
      <Link.AnchorLink href="/">
        <img src={`${communityConfig.logo}?h=75`}/>
      </Link.AnchorLink>
    </div>}
    {buildNav(Constants.navItems, router.pathname, userMenu.user)}
  </Container>
</div>

// Mobile UI Components
export const buildParentMenuMobile =
  (links: Types.NavItem[], toggleSubNavMobile?: any) => <div className="nav-item-mobile">
  {links.map((link: any, i: number) =>
    <div key={link + i}>
        <Row className="nav-item-row-mobile" onClick={() => toggleSubNavMobile(link.href)}>
          <Col xs="10">
            {link.isNoLink ?
              <span>{link.label}</span> :
              <Link.AnchorLink href={'' + link.href}>{link.label}</Link.AnchorLink>}
          </Col>
          {link.children &&
          <Col xs="2">
            <i className={`fas fa-caret-${link.isOpen ? 'up' : 'down'} icon icon-white`}></i>
          </Col>}
        </Row>
        {link.children &&
          link.isOpen ? buildSubNavMenuMobile(link.children, link.href) : null}
    </div>)}
</div>

export const buildSubNavMenuMobile = (children: Types.NavItem[], parentHref: string) => <div>
  {children.map((link: Types.NavItem, i: number) =>
    <Link.AnchorLink key={i} href={link.href}>
      <Row className="sub-nav-item-row-mobile">
        <Col xs="12">{link.label}</Col>
      </Row>
    </Link.AnchorLink>)}
</div>

type MobileStateProps = App.WrappedState &
 Types.WrappedNavState &
 CommunityConfig.CommunitiesWrappedState & CommunityConfig.WrappedState
interface DispatchProps {
  toggleMenu: any,
  toggleSubNavMobile: any
}
type MobileProps = MobileStateProps & DispatchProps

export const MobileNavComponent =
({ app, communityConfig, communities, navState, toggleSubNavMobile, toggleMenu }: MobileProps) =>
  <div className="nav-mobile">
    <Container>
      <Row>
        <Col xs="9" sm="9">
          {communityConfig.logo && <div className="community-logo-mobile">
            <Link.AnchorLink href="/">
              <span>{communities[app.selectedCommunity] ? communities[app.selectedCommunity].name : ''}</span>
            </Link.AnchorLink>
          </div>}
        </Col>
        <Col xs="3" sm="3" onClick={toggleMenu}><span className="menu-text-mobile">Menu</span></Col>
      </Row>
      <Row>
        <Col xs="12">
          <Collapse isOpen={navState.isMenuOpen}>
            {buildParentMenuMobile(navState.navItems, toggleSubNavMobile)}
          </Collapse>
        </Col>
      </Row>
    </Container>
  </div>

export const MobileNavConnected = connect(
  ({ app, communityConfig, communities, navState }: MobileStateProps) =>
  ({ app, communityConfig, communities, navState }),
  {
    toggleMenu: Actions.toggleMainMenuMobile,
    toggleSubNavMobile: Actions.toggleSubNavMobile,
  },
)(MobileNavComponent)

export const LeftNavConnected = connect(
  ({ communityConfig, navState, router, userMenu}: StateProps) => ({communityConfig, navState, router, userMenu}),
)(LeftNavComponent)



// WEBPACK FOOTER //
// ./src/components/menu/left-nav/component.tsx